import * as React from "react";
import { Button } from "../button/button.mjs";
import { Image } from "../image/image.mjs";
const ImageZoom = React.forwardRef(function ImageZoom2(props, ref) {
  const { image, buttonText, className, url, onClick, ...rest } = props;
  const BEM = () => {
    const classArray = ["image-zoom"];
    if (className) {
      classArray.push(className);
    }
    return classArray.join(" ");
  };
  return /* @__PURE__ */ React.createElement("div", { className: BEM() }, /* @__PURE__ */ React.createElement(Image, { ...image }), /* @__PURE__ */ React.createElement(Button, { onClick, className: "image-zoom__button", variant: "secondary", icon: "#zoom-in", text: buttonText, ref, url, ...rest }));
});
export {
  ImageZoom
};
